import notice from "../../../utils/notice";
import {
  getMultipartParams,
  handleResponse,
} from "../../../crud/helpers/validate";
import { TAGS_URL } from "../../../crud/helpers/routes";
import { useContentsContext } from "./useContentsContext.hook";

export const useTags = () => {
  const { setAllTags } = useContentsContext();
  const getTags = async (page = 1, query = "", per_page = 15) => {
    try {
      const res = await fetch(
        `${TAGS_URL}/get_tags?page=${page}&search_query=${query}&per_page=${per_page}`,
        getMultipartParams("GET")
      );
      const json = await handleResponse(res);
      setAllTags(json.items);
    } catch (e) {
      notice("Error on loading tags");
      console.error(e.errors);
    }
  };

  return { getTags };
};
